import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Layout } from '@/components/layout'
import { HomePage } from '@/pages/home'

// Only the index route loads eagerly -- it's what nearly every first-time
// visitor lands on. Every other page is fetched on navigation instead of
// bundled into the initial JS, since bundling them all together was pulling
// down code for pages a given visitor may never open.
const WhatWeDoPage = lazy(() => import('@/pages/what-we-do').then((m) => ({ default: m.WhatWeDoPage })))
const FaqPage = lazy(() => import('@/pages/faq').then((m) => ({ default: m.FaqPage })))
const ContactPage = lazy(() => import('@/pages/contact').then((m) => ({ default: m.ContactPage })))
const PrivacyPolicyPage = lazy(() =>
  import('@/pages/privacy-policy').then((m) => ({ default: m.PrivacyPolicyPage })),
)
const TermsOfServicePage = lazy(() =>
  import('@/pages/terms-of-service').then((m) => ({ default: m.TermsOfServicePage })),
)
const NotFoundPage = lazy(() => import('@/pages/not-found').then((m) => ({ default: m.NotFoundPage })))

function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="what-we-do" element={<WhatWeDoPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="terms-of-service" element={<TermsOfServicePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  )
}

export default App
